import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import { getFromLocalStorage, setInLocalStorage } from 'Client/local-storage-api';
import { ToasterImmersive } from 'Components/frameworks/toaster-immersive/ToasterImmersive';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
const CRISIS_ALERT_LOCALSTORAGE_KEY = 'dismissGlobalAlert';
type Props = {
  alertDate: string;
  linkLabel: string;
  linkUrl: string;
  onClose?: () => void;
  setIsVisible?: (arg0: boolean) => void;
  isSpread?: boolean;
};
export const CrisisAlertLinkBanner = ({
  alertDate,
  linkLabel,
  linkUrl,
  onClose,
  setIsVisible,
  isSpread,
}: Props) => {
  const shouldDisplay =
    !isEmpty(alertDate) &&
    !isEmpty(linkLabel) &&
    !(getFromLocalStorage(CRISIS_ALERT_LOCALSTORAGE_KEY) === alertDate);
  useEffect(() => {
    setIsVisible && setIsVisible(shouldDisplay);
  }, [shouldDisplay]);
  return shouldDisplay ? (
    <ToasterImmersive
      color={COLORS.ORANGE}
      iconName={ICONS.LIGHTBULB}
      onClose={() => {
        setInLocalStorage(CRISIS_ALERT_LOCALSTORAGE_KEY, alertDate);
        onClose && onClose();
      }}
      title={linkLabel}
      url={isSpread ? linkUrl : undefined}
    />
  ) : null;
};
